<template>
  <div>
    <div v-if="!$auth.isUserLogged">
      <h1>No tienes permiso para esta página</h1>
    </div>
    <div v-else>
      <table v-if="menuList !== []" class="table">
        <thead>
          <tr>
            <td>
              <p @click="prevMonth()">❮</p>
            </td>
            <td colspan="5">{{ months[month] }} {{ year }}</td>
            <td>
              <p @click="nextMonth()">❯</p>
            </td>
          </tr>
          <tr>
            <td v-for="(d, index) in day" :key="index">{{ d }}</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(week, i) in Calendar()" :key="i">
            <td
              v-for="(day, j) in week"
              :key="j"
              @click="onDayClicked(day)"
              :class="{
                currentDay: isCurrent(day),
                weekend: isWeekend(day),
                hasMenu: hasMenu(day),
              }"
            >
              <div v-if="active !== day">
                {{ day }}
              </div>
              <div class="icons" v-else>
                <div @click.stop="goToMenu(day)">
                  <svg
                    class="icon"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="eye"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                    data-fa-i2svg=""
                  >
                    <path
                      fill="currentColor"
                      d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
                    ></path>
                  </svg>
                </div>
                <div @click.stop="goToMenuEditor(day)">
                  <svg
                    class="icon"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="edit"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                    data-fa-i2svg=""
                  >
                    <path
                      fill="currentColor"
                      d="M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"
                    ></path>
                  </svg>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";

export default {
  name: "SelectDatePage",
  data() {
    return {
      active: null,
      menuList: [],
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
      day: ["Lu", "Ma", "Mi", "Ju", "Vi", "Sa", "Do"],
      months: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
    };
  },
  computed: {
    dateList() {
      var list = [];
      for (var i = 0; i < this.menuList.length; i++) {
        list.push(this.menuList[i].date);
      }
      return list;
    },
  },
  methods: {
    Calendar() {
      var days = [];
      var week = 0;
      days[week] = [];
      var lastDay = new Date(this.year, this.month + 1, 0).getDate();
      for (let i = 1; i <= lastDay; i++) {
        if (new Date(this.year, this.month, i).getDay() != "1") {
          days[week].push(i);
        } else {
          week++;
          days[week] = [];
          days[week].push(i);
        }
      }

      if (days[0].length > 0) {
        for (let i = days[0].length; i < 7; i++) {
          days[0].unshift("");
        }
      } else {
        days.shift();
      }
      return days;
    },
    isCurrent(day) {
      if (this.dateToString(day) == new Date().toISOString().split("T")[0]) {
        return true;
      }
      return false;
    },
    dateToString(day) {
      return new Date(this.year, this.month, day + 1)
        .toISOString()
        .split("T")[0];
    },
    hasMenu(day) {
      const index = this.dateList.indexOf(this.dateToString(day));
      if (index >= 0) {
        return this.menuList[index].has_menu;
      }
      return false;
    },
    isWeekend(day) {
      if (
        new Date(this.year, this.month, day).getDay() == 6 ||
        new Date(this.year, this.month, day).getDay() == 0
      ) {
        return true;
      }
      return false;
    },
    nextMonth() {
      this.month++;
      if (this.month > 11) {
        this.month = 0;
        this.year++;
      }
      this.menuList = this.getMenuList(this.year, this.month);
    },
    prevMonth() {
      this.month--;
      if (this.month < 0) {
        this.month = 11;
        this.year--;
      }
      this.menuList = this.getMenuList(this.year, this.month);
    },
    onDayClicked(day) {
      if (this.hasMenu(day) && this.active !== day) {
        this.active = day;
      } else {
        this.active = null;
        this.goToMenuEditor(day);
      }
    },
    goToMenu(index) {
      var month = String(this.month + 1).padStart(2, "0");
      var day = String(index).padStart(2, "0");
      this.$router.push(`/menu/${this.year}-${month}-${day}`);
    },
    goToMenuEditor(index) {
      if (index) {
        var month = String(this.month + 1).padStart(2, "0");
        var day = String(index).padStart(2, "0");
        this.$router.push({
          path: `/admin/menu/${this.year}-${month}-${day}/edit`,
        });
      }
    },
    async getMenuList(year, month) {
      console.log(year, month);
      this.menuList = await api.getMonthMenus(year, month + 1);
    },
  },
  async created() {
    if (this.year && this.month) {
      await this.getMenuList(this.year, this.month);
    }
  },
};
</script>

<style>
thead {
  background-color: #a9a9a9;
}
.table {
  margin: auto;
  border-spacing: 0px;
  border-collapse: collapse;
  cursor: pointer;
  font-size: 30px;
}
td {
  text-align: center;
  width: 80px;
  height: 80px;
}
.currentDay {
  border: 3px solid black;
}
.weekend {
  color: #ff0000;
}
.hasMenu {
  background-color: lightseagreen;
}

.icons,
svg {
  display: flex;
  justify-content: center;
  gap: 10px;
}

i,
svg {
  font-size: 18px !important;
  width: 18px;
}

i:hover,
svg:hover {
  opacity: 0.5 !important;
}
</style>
